/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
// file to be removed after removing SearchShellHelperAndModuleLoader from ushell
export default class SearchShellHelperAndModuleLoader {
    constructor() {
        // nothing todo
    }
}
